<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import { defineComponent, onMounted } from "vue";
import { useApiStore } from "@/stores/api";

defineComponent({
  name: "App",
});

onMounted(() => {
  useApiStore().scheduleTokenRefresh();
});
</script>
